import 'whatwg-fetch';
import $ from 'jQuery';

$(document).ready(function () {
  setTimeout(function () {
    $('.loading').fadeOut(800);
  }, 1000);
});